<!-- 公司图片 -->
<template>
    <div v-if="componentsData.type == 11"
        :style="`padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};`"
    >
        <div class="swiper-container h100" v-if="companyData.show_pic.length"
            :style="`border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`"
        >
            <Carousel class="h100" v-if="componentsData.content.autoplay == 1" v-model="componentsData.content.value" radius-dot>
                <CarouselItem v-for="(item, index) of companyData.show_pic" :key="index"
                    :style="
                        componentsData.content.height_id == 1
                            ? 'height: 375px;'
                            : componentsData.content.height_id == 2
                            ? 'height: 187.5px;'
                            : componentsData.content.height_id == 3
                            ? 'height: 281.25px;'
                            : componentsData.content.height_id == 4
                            ? 'height: 500px;'
                            : componentsData.content.height_id == 5
                            ? 'height: 750px;'
                            : 'height: 375px;'
                    "
                >
                    <img class="w100" :src="item"
                        :style="`border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`"
                    />
                </CarouselItem>
            </Carousel>
            <div v-else
                :style="
                    componentsData.content.height_id == 1
                        ? 'height: 375px;'
                        : componentsData.content.height_id == 2
                        ? 'height: 187.5px;'
                        : componentsData.content.height_id == 3
                        ? 'height: 281.25px;'
                        : componentsData.content.height_id == 4
                        ? 'height: 500px;'
                        : componentsData.content.height_id == 5
                        ? 'height: 750px;'
                        : 'height: 375px;'
                "
            >
                <imgStyle class="h100" :imgData="componentsData" :imgList="companyData.show_pic"></imgStyle>
            </div>
        </div>
        <div class="none-div" v-else>
            请上传公司图片
        </div>
    </div>
</template>

<script>
import imgStyle from "@/components/imgStyle/imgStyle.vue";
export default {
    components: {
        imgStyle,
    },
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
        companyData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.swiper-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    z-index: 1;
    width: 100%;
    height: 150px;
}
.h100 {
    height: 100%;
}
.w100 {
    width: 100%;
    height: 100%;
}
.none-div {
    font-size: 14px;
    color: #808080;
}
</style>